import { css } from 'styled-system/css';
import { center, flex } from 'styled-system/patterns';

export const leagueStyles = {
	league: css({
		_mars: {
			marginBottom: '6px',
			borderBottomRightRadius: '6px',
			borderBottomLeftRadius: '6px',
			overflow: 'hidden',
			'&:not(first-child)': {
				borderTopRightRadius: '6px',
				borderTopLeftRadius: '6px',
			},
			// favorit icon active color
			'& .btn--favorite': {
				_active: {
					color: 'warning.base',
					filter: 'none'
				}
			}
		}
	}),
	header: flex({
		_mars: {
			p: '3px 0 3px 9px',
			justifyContent: 'space-between',
			alignItems: 'center',
			bgColor: 'league.bg',
			cursor: 'pointer',
			minH: '36px',
			'& .icon': {
				w: '20px',
				h: '20px',
			},
			'& .btn': {
				w: '30px',
				h: '30px',
				color: 'black.3',
				'&[data-show=false]': {
					display: 'none',
				}
			}
		}
	}),
	flag: center({
		_mars: {
            
		}
	}),
	text: css({
		_mars: {
			lineHeight: '15px',
			color: 'black.1',
		}
	}),
	badge: center({
		_mars: {
			fontSize: '12px',
			color: 'black.2',
			bg: 'black.5',
			borderRadius: '6px',
			fontWeight: '500',
			lineHeight: '15px',
			minWidth: '21px',
			p: '3px',
			mr: '5px',
			animation: 'fadein .3s',
			'&[data-show=false]': {
				display: 'none',
			}
		}
	}),
	matchGroup: css({
		overflow: 'hidden',
		backgroundColor: 'match.bg',
		willChange: 'unset!',
	}),

	oddsBoostPromo: css({
		backgroundImage: 'url("/images/promotion/odds-boost-promo/league-promo-left.png"), url("/images/promotion/odds-boost-promo/league-promo-right.png"), linear-gradient(49deg, rgba(249, 0, 112, 0.06) 0%, rgba(255, 178, 13, 0.06) 100%)',
		backgroundRepeat: 'no-repeat',
		backgroundSize: 'contain, contain, cover',
		backgroundPosition: 'left top, right top, center',		
	}),

	oddsBoostIcon: css({
		width: '24px',
		_galaxy: {
			transform: 'rotate(-30deg)',
		}
	}),

	nbaTag: css({
		color: '#0C4EB1',
		fontWeight: '700',
		flex: '0 1 auto',
		_dark: {
			color: '#76C5FF',
		}
	}),

	nbaDetail: css({
		base: {
			w: '24px !important',
			h: '24px !important',
			color: 'var(--text-neutral-950-80-050-80)',
		},
		_mars: {
			color: 'var(--colors-black-3)',
		}
	}),
	nameWrapper: css({
		base: {
			display: 'flex',
			alignItems: 'center',
			flex: 1,
		},
		_mars: {
			ml: '8px',
			mr: 'auto',
			lineHeight: '15px',
			color: 'black.1',
			flex: 'auto'
		}
	}),
	detailWrapper: css({
		base: {
			flex: '0 0 auto',
			mr: 'auto',
		}
	}),
}